<template>
  <section id="pricing" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-card style="width: 100%">
            <h1 class="text-center pt-6 font-weight-light display-2">Asesores</h1>
            <v-divider class="my-6"></v-divider>
            <v-row class="pl-3 pr-3">
              <v-col
                v-for="(asesor, index) in asesores"
                :key="index"
                cols="12"
                md="6"
              >
                <v-card
                  flat
                  class="pa-4 h-100"
                >
                  <div class="d-flex flex-column flex-sm-row align-center">
                    
                    <v-img
                      :src="getImage(asesor.imagen)"
                      class="rounded-circle mb-4 mb-sm-0 mr-sm-4 flex-shrink-0"
                      max-width="110"
                      max-height="110"
                      contain
                    ></v-img>

                    <div class="text-center text-sm-left w-100">
                      <h4>{{ asesor.nombre }}</h4>

                      <label>Asesor inmobiliario</label>

                      <p
                        v-if="asesor.email"
                        class="mt-2 mb-2"
                        style="word-break: break-word;"
                      >
                        {{ asesor.email }}
                      </p>

                      <div class="d-flex justify-center justify-sm-start">
                        
                        <a
                          v-if="asesor.instagram"
                          :href="asesor.instagram"
                          target="_blank"
                        >
                          <v-icon
                            large
                            color="green darken-2"
                            class="mr-2"
                          >
                            mdi-instagram
                          </v-icon>
                        </a>

                        <a
                          v-if="asesor.facebook"
                          :href="asesor.facebook"
                          target="_blank"
                        >
                          <v-icon
                            large
                            color="blue darken-2"
                            class="mr-2"
                          >
                            mdi-facebook
                          </v-icon>
                        </a>

                        <a
                          v-if="asesor.linkedin"
                          :href="asesor.linkedin"
                          target="_blank"
                        >
                          <v-icon
                            large
                            color="purple darken-2"
                          >
                            mdi-linkedin
                          </v-icon>
                        </a>

                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-rounded text-light">
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 144.54 17.34"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <path
          d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
        />
      </svg> -->
      <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
          fill="currentColor"
      >
        <path
            d="M0,64L80,90.7C160,117,320,171,480,181.3C640,192,800,160,960,138.7C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        ></path>
      </svg>
    </div>
  </section>
</template>

<style lang="scss" scoped>
a{
  text-decoration: none;
}
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.header {
  background-color: #283e79;
  color: white;
}
a {
  text-decoration: none;
}

.rounded-circle {
  border-radius: 50%;
}
.circle1 {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle2 {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}

#pricing {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
</style>

<script>
export default {
  data: () => ({
    asesores: [
      {
        nombre: "Miguel Castillejos",
        imagen: "miguel.jpeg",
        instagram: "https://www.instagram.com/miguel.castillejos.re?igsh=ZWJobmRvcTR6cXlv&utm_source=qr",
        facebook: "https://www.facebook.com/share/1BPXZDKDVc/?mibextid=wwXIfr"
      },
      {
        nombre: "Karely Tamayo",
        imagen: "karely.jpeg",
        instagram: "https://www.instagram.com/karely_tamayo?igsh=a2FzMzN0NXVzbXAx&utm_source=qr",
        facebook: "https://www.facebook.com/share/1bAXvY9Yog/?mibextid=wwXIfr"
      },
      {
        nombre: "Rodrigo Castillejos",
        imagen: "rodrigo.jpeg",
        instagram: "https://www.instagram.com/rodriigo_cast?igsh=eWlnbzF4anBmMGp5&utm_source=qr",
        facebook: "https://www.facebook.com/share/1Gvp91dp5W/?mibextid=wwXIfr"
      },
      {
        nombre: "Federico Méndez",
        imagen: "federico.jpeg",
        instagram: "https://www.instagram.com/federico.polancorp?igsh=MWtpZzR4N2Z2eXh5dw==",
        facebook: "https://www.facebook.com/share/1BMDSD1UQA/"
      },
      {
        nombre: "Jaime Alfaro",
        imagen: "jaime.jpeg",
        instagram: "https://instagram.com/jaimepolancorp?igshid=ZmZhODViOGI=",
        facebook: "https://www.facebook.com/ca.alheg"
      },
      {
        nombre: "Rafael Castillejos",
        imagen: "rafael.jpeg",
        instagram: "https://www.instagram.com/rafa_polancorp?igsh=dTM5dWR5NnR6aGE=",
        facebook: "https://www.facebook.com/share/1FZUzCTzKx/?mibextid=wwXIfr"
      },
      {
        nombre: "Karen Ramos",
        imagen: "karen.jpeg",
        instagram: "https://www.instagram.com/karenramos_bienesraices?igsh=N3Z6cWhreWdlYjNt&utm_source=qr",
        facebook: "https://www.facebook.com/share/18JKSEcVCK/?mibextid=wwXIfr"
      },
      {
        nombre: "Pako Vera",
        imagen: "paco.jpeg",
        instagram: "https://www.instagram.com/pakopolanco?igsh=OHAwdzA5dGtqNWNw",
        facebook: "https://www.facebook.com/share/18QtoLpzjA/?mibextid=wwXIfr"
      },
      {
        nombre: "Amairani Vázquez",
        imagen: "amairani.jpeg",
        instagram: "https://www.instagram.com/amairanivzquez?igsh=dmpiY3N1MmxhNjdv",
        facebook: "https://www.facebook.com/share/1KSMtMj7jc/?mibextid=wwXIfr"
      },
      {
        nombre: "Viridiana Santiago",
        imagen: "viridiana.jpeg",
        instagram: "https://www.instagram.com/viriz9?igsh=emc3N3J3Ym14enM4&utm_source=qr",
        facebook: "https://www.facebook.com/share/1LCiCfGwps/?mibextid=wwXIfr"
      },
      {
        nombre: "Isela Gómez",
        imagen: "isela.jpeg",
        facebook: "https://www.facebook.com/share/1GPZr57agk/"
      },
      {
        nombre: "Diana Santos",
        imagen: "diana.jpeg",
        facebook: "https://www.facebook.com/share/17Ym2LphS2/?mibextid=wwXIfr"
      },
      {
        nombre: "Gustavo Zwanziger",
        imagen: "eli.jpeg",
        facebook: "https://www.facebook.com/share/1FV9rtrJpw/"
      }
    ]
  }),

  methods: {
    getImage(imagen) {
      try {
        return require(`@/assets/img/${imagen}`)
      } catch (e) {
        return require('@/assets/img/default-user.jpeg')
      }
    }
  },

  computed: {
    size() {
      const size = {md: "large", xl: "x-large"}[
          this.$vuetify.breakpoint.name
          ];
      return size ? {[size]: true} : {};
    }
  },
};
</script>